<template>
    <div class="container-fluid  pt-2" >
        <div class="container pt-5">

        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-12">
                    <div class="py-3">
                        <h4 class="text-weight-900 text-primary">Leave Applications</h4>
                    </div>
                </div>
                <div class="col-md-6 col-12">

                </div>

            </div>
            <b-table
                    sticky-header
                    hover
                    :items="leavetable.items"
                    :fields="leavetable.fields"
                    sort-icon-left
                    responsive="sm"


            >
                <template #cell(index)="data">
                    <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
                    <span>{{ data.index + 1 }}</span>

                </template>
                <template #cell(status)="data">
                    <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
                    <span v-if="data.item.status === null"><span class="badge badge-pill badge-primary py-2 px-3 underline-primary mr-1" v-on:click="ActionLeave('approve',data.item.leave_id)">Approve</span><span class="badge badge-pill badge-danger py-2 px-3 underline-primary" v-on:click="ActionLeave('reject',data.item.leave_id)">Reject</span></span>
                    <span  v-else-if="data.item.status === 1"><h6 class="badge badge-pill badge-success py-2 px-3">Approved</h6></span>
                    <span v-else="data.item.status === 0"><h6 class="badge badge-pill badge-danger py-2 px-3">Declined</h6></span>


                </template>

            </b-table>





        </div>





    </div>
</template>

<script>
    export default {
        name: "leaveapplications",
        data(){
            return{
                leavetable:{
                    items:[],
                    fields:[
                        "index",
                        {key:"applicant",sortable:true},
                        {key:"from",sortable:true},
                        {key:"to",sortable:true},
                        {key:"reason",sortable:true},
                        {key:"date_applied",sortable:true},
                        {key:"status",sortable:true},
                    ]
                }
            }
        },
        methods:{
            GetLeaveApplications()
            {
                axios.get('/api/leave-applications').then(results=>{
                    console.log(results.data);
                    let leavearray = [];
                    let user_name = '';

                    $.each(results.data,function (key,value) {
                        if(value.user !== null)
                        {
                           user_name = (value.user.full_name === null) ? value.user.name : value.user.full_name;
                        }
                        leavearray.push(
                            {applicant:user_name,from:moment(value.start_date).format('DD-MMM-YYYY'),to:moment(value.end_date).format('DD-MMM-YYYY'),reason:value.reason,status:value.approval,date_applied:moment(value.created_at).fromNow(),leave_id:value.id}
                        );
                    });
                    console.log(leavearray);
                    this.leavetable.items = leavearray

                }).catch(error=>{
                    console.log(error)
                })
            },
            ActionLeave(action,id){
                console.log(id);
                axios.post('/api/approve-leave',{action:action,leave_id:id}).then(results=>{

                    this.$toasts.push({
                        type: results.data.type,
                        message: results.data.message,
                    });
                    this.GetLeaveApplications()
                }).catch(error=>{
                    console.log(error.data)
                });
            },
        },
        mounted() {
            this.GetLeaveApplications()
        }
    }
</script>

<style scoped>

</style>